import React from 'react';
import {
  UcatTimedPreScreen,
  ucatBodyText,
  ucatSectionHeading,
  ucatBulletList,
  ucatBulletItem,
} from './UcatTimedPreScreen';

/** Screenshot 1 — GENERAL TEST INFORMATION (4 minutes). */

const UcatGeneralInfoScreen = ({ paperTitle, colorScheme, setColorScheme, onNext, onEndExam, pearsonSitting = false }) => (
  <UcatTimedPreScreen
    examName="UCAT"
    paperTitle={paperTitle}
    colorScheme={colorScheme}
    setColorScheme={setColorScheme}
    onNext={onNext}
    onEndExam={onEndExam}
    durationSeconds={240}
    showHelp
    showEndExam={false}
    pearsonSitting={pearsonSitting}
  >
    {({ ink }) => {
      const body = ucatBodyText(ink);
      const heading = ucatSectionHeading(ink);
      const list = ucatBulletList(ink);
      const item = ucatBulletItem(ink);
      return (
        <>
          <p style={{ ...heading, fontSize: '16px', marginBottom: '12px' }}>
            GENERAL TEST INFORMATION
          </p>
          <p style={{ ...body, fontWeight: 700 }}>
            You have 4 minutes to read this screen. Please take time to read this screen as it includes important test information.
          </p>
          <ul style={list}>
            <li style={item}>
              You should have been given a <strong>laminated notebook</strong> and <strong>pen</strong>. If you need a replacement during your test, hold the item in the air to request one. Check your pen is working before you start to avoid interruptions during the test.
            </li>
            <li style={item}>
              Under <strong>normal test centre conditions</strong> there may be limited disturbance as other test takers arrive and leave or staff assist them. You may request <strong>earplugs</strong> to block out noise.
            </li>
            <li style={item}>
              You may <strong>magnify the screen</strong> (up to 200%) using Ctrl +/- to <strong>zoom in or out</strong>; Ctrl 0 (zero) <strong>resets zoom</strong> to 100%.
            </li>
            <li style={item}>
              You may select a different <strong>Colour Scheme</strong> from the drop-down at the top right of the screen.
            </li>
            <li style={item}>
              Use your <strong>mouse</strong> to navigate through the test. <strong>Keyboard shortcuts</strong> can be used for some actions (e.g. Alt and n = next). If shortcuts do not work, use your mouse.
            </li>
            <li style={item}>
              If you need to <strong>leave the test room</strong> (e.g. to use the toilets), raise your hand to notify the invigilator. Unless you have been approved for rest breaks (see below), the test cannot be paused and you will lose time when out of the room. Try and take breaks between subtests to limit impact on test time.
            </li>
          </ul>

          <p style={{ ...heading, fontSize: '14.5px', marginTop: '8px' }}>
            INFORMATION ONLY FOR CANDIDATES APPROVED FOR REST BREAKS AS AN ACCESS ARRANGEMENT
          </p>
          <p style={body}>
            Pause the clock breaks can be applied for as an access arrangement if you are entitled to these in public examinations. Only candidates that have been approved for rest breaks will have this functionality in the live test.
          </p>
          <p style={body}>
            We are unable to integrate this functionality into our practice materials. Please refer to the guidance on our website at{' '}
            <a
              href="https://www.ucat.ac.uk/register/access-arrangements/pause/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: ink }}
            >
              https://www.ucat.ac.uk/register/access-arrangements/pause/
            </a>
          </p>
          <p style={body}>
            This is the text you will see in the live test:{' '}
            <em>
              There is a &apos;Pause Exam&apos; button at the top right of the screen. This allows breaks without losing test time. You may wish to practise using this feature now. Instructions are available via the Help button (bottom left of the screen). Test time will continue to count down while using the Help button.
            </em>
          </p>
          <p style={{ ...body, marginBottom: 0 }}>
            Please click the{' '}
            <strong>
              Next (<span style={{ textDecoration: 'underline' }}>N</span>)
            </strong>{' '}
            button to proceed before the time on this screen expires.
          </p>
        </>
      );
    }}
  </UcatTimedPreScreen>
);

export default UcatGeneralInfoScreen;
